import React, { useState } from "react";
import { useGetAllDownloadsQuery } from "../../Redux/getApi";
import { FiX } from "react-icons/fi";
import { FaDownload } from "react-icons/fa";
import { MdRemoveRedEye } from "react-icons/md";
import { handleDownload } from "../../utilis/utils";

/* =========================
   PREVIEW HELPERS (DROP-IN)
========================= */
const normalizeMime = (mime) =>
  (mime || "").toLowerCase().split(";")[0].trim();

const getExt = (name = "", url = "") => {
  const fromName = (name || "").split(".").pop();
  const cleanUrl = (url || "").split("?")[0].split("#")[0];
  const fromUrl = cleanUrl.split(".").pop();
  return (fromName || fromUrl || "").toLowerCase();
};

const canPreview = (doc) => {
  if (!doc?.docUrl) return false;

  const mime = normalizeMime(doc?.fileType);
  const ext = getExt(doc?.fileName, doc?.docUrl);

  const isPdf = mime === "application/pdf" || ext === "pdf";
  const isImage =
    mime.startsWith("image/") ||
    ["png", "jpg", "jpeg", "webp", "gif", "svg"].includes(ext);

  return isPdf || isImage;
};

const getPreviewType = (doc) => {
  const mime = normalizeMime(doc?.fileType);
  const ext = getExt(doc?.fileName, doc?.docUrl);

  if (mime === "application/pdf" || ext === "pdf") return "application/pdf";
  if (mime.startsWith("image/")) return mime;

  if (["png", "jpg", "jpeg", "webp", "gif", "svg"].includes(ext)) {
    return `image/${ext === "jpg" ? "jpeg" : ext}`;
  }

  return mime || "unknown";
};
/* ========================= */

const Downloads = () => {
  const [viewFile, setViewFile] = useState(null);
  const [directorates, setDirectorates] = useState("");
  const {
    data: downloadsResponse,
    isLoading,
    isFetching,
    error,
  } = useGetAllDownloadsQuery(directorates, {
    refetchOnMountOrArgChange: true,
    selectFromResult: ({ data, ...rest }) => {
      return {
        ...rest,
        data: data?.downloads?.length ? data : { downloads: [] },
      };
    },
  });

  const downloads = downloadsResponse || [];

  const loading = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <div className="flex flex-col gap-10  md:py-20 py-10 xl:px-[5%] lg:px-[3%] md:px-[2%] px-[6%] ">
      <div className="flex flex-col gap-4">
        <h1 className="xl:text-[2.5rem] lg:text-[1.8rem]  text-[2rem] font-bold text-center">
          Downloads
        </h1>
        <p className="xl:text-[1.2rem] md:text-[1rem] text-[.9rem] text-center text-[#7A7A7A]">
          Click on links below to download
        </p>
      </div>

      <div className="flex md:flex-row flex-col justify-between gap-2 md:items-center items-start bg-white py-2 md:px-4 px-2  rounded-lg  w-full">
        <span className=" md:text-[1.2rem] text-base font-medium">
          Filter by Directorates
        </span>
        <select
          name="directorates"
          value={directorates}
          onChange={(e) => setDirectorates(e.target.value)}
          className=" border border-[#00000033]  bg-[#F6F6F6] outline-none md:text-[.8rem] text-[.7rem] md:p-2 p-1.5  rounded-md"
        >
          <option value="">All</option>
          <option value="Administration And Finance">
            Administration And Finance
          </option>
          <option value="Directorate of Engineering">
            Directorate of Engineering
          </option>
          <option value="Land Development & Estate Management">
            Land Development & Estate Management
          </option>
          <option value="Metropolitan Planning & Traffic Engineering">
            Metropolitan Planning & Traffic Engineering
          </option>
        </select>
      </div>

      {isLoading || isFetching ? (
        <div className=" grid md:grid-cols-2 grid-cols-1 lg:gap-8 gap-6 ">
          {loading.map((i) => (
            <div
              key={i}
              className="bg-[#EFEFEF] animate-pulse p-3 rounded-xl flex flex-col gap-1.5"
            >
              <p className=" bg-[#97979750] h-5 rounded-lg animate-pulse w-[90%]"></p>
              <p className=" bg-[#97979750] h-4 rounded-lg animate-pulse w-[70%]"></p>
              <p className=" bg-[#97979750] h-4 rounded-lg animate-pulse w-[50%]"></p>
            </div>
          ))}
        </div>
      ) : (
        downloads &&
        !error &&
        (downloads?.downloads?.length === 0 ? (
          <div className=" text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold text-[#000000]">
            No download Found
          </div>
        ) : (
          <div className="grid md:grid-cols-2 grid-cols-1 lg:gap-8 gap-6">
            {downloads?.downloads?.map((d, i) => (
              <div
                key={i}
                className="bg-[#DEE9E4] lg:p-4 p-3 rounded-2xl flex flex-col lg:gap-3 gap-2"
              >
                <div className="flex justify-between items-center gap-2 lg:text-[1.8rem] text-[1.5rem]  font-semibold text-[#00643b]">
                  {/* <h1>Downloads </h1> */}
                  <div className=" flex items-center justify-end w-full gap-2">
                    {canPreview(d?.doc) && (
                      <MdRemoveRedEye
                        className="size-6 cursor-pointer"
                        onClick={() =>
                          setViewFile({
                            url: d?.doc?.docUrl,
                            mimeType: getPreviewType(d?.doc),
                          })
                        }
                      />
                    )}

                    <button
                      onClick={() =>
                        handleDownload(
                          d?.doc?.docUrl,
                          `${d?.doc?.fileName || "file"}`,
                          d?.doc?.fileType
                        )
                      }
                      className=" text-[#00643b]"
                      aria-label="Download file"
                    >
                      <FaDownload className="size-6 " />
                    </button>
                  </div>
                </div>
                <p className="lg:text-[1.1rem] md:text-[1rem] text-[.85rem]">
                  {d.title}
                </p>
              </div>
            ))}
          </div>
        ))
      )}

      {viewFile && (
        <div className="fixed inset-0 bg-black bg-opacity-10 backdrop-blur-sm flex items-center justify-center z-[200]">
          <div className="relative bg-white/80 border border-white/30 backdrop-blur-lg rounded-2xl shadow-xl p-4  w-[90%] h-[95vh]  animate-fade-in text-black">
            <button
              onClick={(e) => {
                e.stopPropagation();
                setViewFile(null);
              }}
              className="absolute top-4 right-4 text-[#00643b]"
              aria-label="Close modal"
            >
              <FiX className="size-6" />
            </button>
            <h2 className="text-[1.5rem] font-bold lg:mb-4 mb-3 text-[#00643b]">
              Download file
            </h2>

            {normalizeMime(viewFile.mimeType) === "application/pdf" ? (
              <iframe
                src={viewFile.url}
                width="100%"
                height="90%"
                className="rounded-[1rem] mt-2"
                title="PDF Preview"
              />
            ) : normalizeMime(viewFile.mimeType).startsWith("image/") ? (
              <img
                src={viewFile.url}
                alt="file Preview"
                className="rounded-[1rem] mt-2 w-full h-[90%]  object-contain"
              />
            ) : (
              <p className="text-red-500 mt-4  text-center">
                This file type cannot be previewed.
              </p>
            )}
          </div>
        </div>
      )}

      {error && (
        <p className=" text-red-500 text-center md:text-[1rem] text-sm bg-red-100 p-2 rounded-lg">
          {error?.data?.message || error?.data?.error}
        </p>
      )}
    </div>
  );
};

export default Downloads;
